import axios from 'axios';
import Swal from 'sweetalert2'; // Import SweetAlert
const currentMonth = new Date().getMonth() + 1
const currentYear = new Date().getFullYear();
export const fetchPayrollByMonthAndYear = async ({month, year,setLoading}) => {
    try {setLoading(true)
        const response = await axios.get(`/get-payrolls`, {
            params: {
                month: month,
                year: year
            }, headers: {
                'Cache-Control': 'no-cache'
            }
        });

        //console.log('Payroll Records:', response.data.payrollRecords);
        setLoading(false) 
        return response.data.payrollRecords;
        
    } catch (error) {
       
        if(month !== currentMonth || year !== currentYear){
        
        Swal.fire({
            title: 'Error!',
            text: error.response ? error.response.data.message : 'An error occurred while fetching payroll records.',
            icon: 'error',
            confirmButtonText: 'Try Again'
        });
    }
     setLoading(false)
    }
};

export const fetchPayrollBySearch = async ({month, year,name,epf_number,center,branch,setLoading}) => {
    try {setLoading(true)
        const response = await axios.get(`/search-payrolls`, {
            params: {
                month: month,
                year: year,
                name:name,
                epf_number:epf_number,
                center:center,
                branch:branch

            }, headers: {
                'Cache-Control': 'no-cache'
            }
        });

        //console.log('Payroll Records:', response.data.payrollRecords);
        setLoading(false) 
        return response.data;
        
    } catch (error) {
       
        if(month !== currentMonth || year !== currentYear){
        
        Swal.fire({
            title: 'Error!',
            text: error.response ? error.response.data.message : 'An error occurred while fetching payroll records.',
            icon: 'error',
            confirmButtonText: 'Try Again'
        });
    }
     setLoading(false)
    }
};


// Function to fetch all payrolls
export const fetchAllPayrolls = async (month,year) => {
    try {
        const response = await axios.get('/get-saved-payrolls', {
            params: {
                month:month,
                year:year,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching payrolls:', error.message);
        throw error; // Rethrow error for further handling
    }
};


export const calculatePayrolls = async (startDate, endDate) => {
    try {
        const response = await axios.get('/payroll-controller', {
            params: {
                startDate: startDate,
                endDate: endDate,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error calculating payrolls:', {
            message: error.message,
            response: error.response?.data,
        });
        const errorMessage = error.response?.data?.message || 'Failed to calculate payrolls. Please try again.';
        console.error(errorMessage);
        throw error;
    }
};

export const updateManualOvertimePay = async (payrollId, manualOvertimePay) => {
  try {
    const response = await axios.put('/manual-overtime', {
      payrollId,
      manualOvertimePay
    });
    return response.data;
  } catch (error) {
    console.error('Error updating manual overtime:', error);
    throw error;
  }
};

// Method for Get Payslip by user, Month & Year
export const getUserPayroll = async (month, year) => {
    try {
      const token = localStorage.getItem("token");
      
      console.log(`Fetching payroll data for month: ${month}, year: ${year}`);
      console.log(`Using token: ${token ? 'Token exists' : 'No token found'}`);
      
      const url = `/user-payroll`;
      console.log(`Making request to: ${url}`);

      const config = {
        params: { month, year },
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json'
        },
        timeout: 30000 // Increased to 30 seconds
      };
      
      const response = await axios.get(url, config);
      
      console.log("API Response status:", response.status);
      console.log("API Response data:", response.data);
      
      return response.data;
    } catch (error) {
      console.error("Error fetching payroll data:");
      
      if (error.response) {
        console.error("Response error data:", error.response.data);
        console.error("Response error status:", error.response.status);
        console.error("Response error headers:", error.response.headers);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Request setup error:", error.message);
      }
      
      throw new Error(`Payroll data fetch failed: ${error.message}`);
    }
  };
  

  export const sendPayslipEmail = async (pdfBase64, month, employeeName, email, password) => {
    try {
      const token = localStorage.getItem("token");
  
      const response = await axios.post(
        "/send-payslip",
        {
          pdfBase64,
          month,
          employeeName,
          email,
          password, 
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      return response.data;
    } catch (error) {
      console.error("Error sending payslip email:", error);
      throw error;
    }
  };





export const sendIndividualPayslip = async (payrollId) => {
  try {
    const response = await axios.post(`/email/individual/${payrollId}`);
    
    if (response.data.success) {
      return {
        success: true,
        message: response.data.message,
        data: response.data.data
      };
    } else {
      return {
        success: false,
        message: response.data.message || 'Failed to send payslip',
        error: response.data.error
      };
    }
  } catch (error) {
    let errorMessage = 'Failed to send payslip';
    if (error.response) {
      errorMessage = error.response.data.message || errorMessage;
    }
    
    return {
      success: false,
      message: errorMessage,
      error: error.response?.data?.error || error.message
    };
  }
};

export const sendBulkPayslips = async (month, year) => {
  try {
    const response = await axios.post('/email/bulk', { month, year });
    
    if (response.data.success) {
      return {
        success: true,
        message: response.data.message,
        data: response.data.results
      };
    } else {
      return {
        success: false,
        message: response.data.message || 'Failed to send payslips',
        error: response.data.error
      };
    }
  } catch (error) {
    let errorMessage = 'Failed to send payslips';
    if (error.response) {
      errorMessage = error.response.data.message || errorMessage;
    }
    
    return {
      success: false,
      message: errorMessage,
      error: error.response?.data?.error || error.message
    };
  }
};

export const fetchNoPayBreakdown = async (payrollId) => {
  try {
    const response = await axios.get(`/payroll/nopay-breakdown/${payrollId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching No Pay breakdown:', error.message);
    throw error;
  }
};